// src/Landing.jsx
import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";

export default function Landing() {
  return (
    <div className="landing-page">
      <style>{`
        .landing-page{
          min-height:100vh;
          display:flex;
          align-items:center;
          justify-content:center;
          padding: 44px 16px;
          position:relative;
          overflow:hidden;
          background:
            radial-gradient(900px 600px at 18% 12%, rgba(47,123,255,.26), transparent 60%),
            radial-gradient(900px 600px at 82% 18%, rgba(255,77,109,.14), transparent 60%),
            radial-gradient(900px 600px at 50% 92%, rgba(32,201,151,.12), transparent 60%),
            linear-gradient(180deg, #060a13 0%, #0b1220 100%);
        }
        .landing-page::before{
          content:"";
          position:absolute;
          inset:-240px;
          background:
            repeating-linear-gradient(
              0deg,
              rgba(255,255,255,.04) 0px,
              rgba(255,255,255,.04) 1px,
              transparent 1px,
              transparent 14px
            );
          opacity:.55;
          pointer-events:none;
        }

        .shell{
          position:relative;
          z-index:1;
          width:100%;
          max-width: 620px;
        }

        .cardx{
          border-radius: 22px;
          padding: 26px 22px;
          background: rgba(255,255,255,.10);
          border: 1px solid rgba(255,255,255,.16);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          box-shadow: 0 18px 50px rgba(0,0,0,.42);
          color: #fff;
        }

        .title{
          margin:0;
          font-weight: 900;
          letter-spacing:.3px;
          text-align:center;
        }
        .sub{
          margin-top: 10px;
          text-align:center;
          color: rgba(234,240,255,.72);
          font-weight: 800;
          font-size: 13px;
        }

        .divider{
          border-top: 1px solid rgba(255,255,255,.12);
          margin: 18px 0;
        }

        .btnx{
          width: 100%;
          border-radius: 16px;
          padding: 14px 16px;
          font-weight: 900;
          border: 0;
          text-decoration: none;
          display:flex;
          align-items:center;
          justify-content:center;
          letter-spacing:.2px;
        }

        /* ✅ 4 unique colors */
        .btn-student{
          color: #071b10;
          background: linear-gradient(135deg, rgba(21,199,119,1), rgba(34,197,94,1));
          box-shadow: 0 14px 38px rgba(21,199,119,.28);
        }
        .btn-staff{
          color: #0b0214;
          background: linear-gradient(135deg, rgba(168,85,247,1), rgba(236,72,153,1));
          box-shadow: 0 14px 38px rgba(168,85,247,.24);
        }
        .btn-driver{
          color: #fff;
          background: linear-gradient(135deg, rgba(47,123,255,1), rgba(106,166,255,1));
          box-shadow: 0 14px 38px rgba(47,123,255,.30);
        }
        .btn-admin{
          color: #1a0b00;
          background: linear-gradient(135deg, rgba(255,149,0,1), rgba(255,77,109,1));
          box-shadow: 0 14px 38px rgba(255,149,0,.22);
        }

        .note{
          margin-top: 14px;
          text-align:center;
          color: rgba(234,240,255,.66);
          font-weight: 800;
          font-size: 12.5px;
        }
      `}</style>

      <div className="shell wow animate__animated animate__fadeInUp animate__slow">
        <div className="cardx">
          {/* ✅ CHANGED TITLE HERE */}
          <h1 className="title">DMI College Bus Tracking</h1>

          <div className="sub">Secure login • Live bus status • Route updates</div>

          <div className="divider" />

          <div className="d-grid gap-3">
            <Link to="/student-login" className="btnx btn-student">
              Student Login
            </Link>

            <Link to="/staff-login" className="btnx btn-staff">
              Staff Login
            </Link>

            <Link to="/driver-login" className="btnx btn-driver">
              Driver Login
            </Link>

            <Link to="/admin-login" className="btnx btn-admin">
              Admin Login
            </Link>
          </div>

          <div className="note">Note: Email/Password only (no Google login).</div>
        </div>
      </div>
    </div>
  );
}